import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import swal from 'sweetalert2';
import { AddEditAiFollowupConfigComponent } from './addEditAiFollowupConfig.component';
import { AiFollowupConfigService } from '../../../services/index';

@Component({
    selector: 'ai-followup-config-tab',
    templateUrl: './aiFollowupConfig.component.html',
})
export class AiFollowupConfigMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    isLoadMask: Promise<any>;
    loadingIndicator = true;
    reorderable = true;
    suppressPaging = false;
    filterExpand = false;
    filterData = { search_data: '' };

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'c.config_id',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('followupTypeTemplate') followupTypeTemplate: TemplateRef<any>;
    @ViewChild('retryTemplate') retryTemplate: TemplateRef<any>;
    @ViewChild('teamTemplate') teamTemplate: TemplateRef<any>;
    @ViewChild('infoTemplate') infoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    configData: any[] = [];
    dropdowns: any = { aiStatus: [], followupTypes: [], trackDays: [], followupTeams: [] };
    bsModalRef: BsModalRef;

    constructor(private aiFollowupConfigService: AiFollowupConfigService, private modalService: BsModalService) {}

    ngOnInit() {
        this.columns = [
            { name: 'SNo',           prop: 'sno',               width: 60,  minWidth: 60,  maxWidth: 60,  cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'AI Status',     prop: 'ai_status_name',    width: 160, minWidth: 160, maxWidth: 160 },
            { name: 'Follow Up Type',prop: 'followup_type_name',width: 150, minWidth: 150, maxWidth: 150, cellTemplate: this.followupTypeTemplate },
            { name: 'Max Retry Count', prop: 'max_retry_count', width: 150, minWidth: 150, maxWidth: 150, cellClass: 'cell-center' },
            { name: 'Call Retry Days', prop: 'track_day_config',width: 280, minWidth: 280, sortable: false, cellTemplate: this.retryTemplate },
            { name: 'Followup Team', prop: 'followup_team_name',width: 150, minWidth: 150, cellTemplate: this.teamTemplate },
            { name: 'Info',         prop: 'info_notes',        width: 100,  minWidth: 100,  maxWidth: 100,  sortable: false, cellClass: 'cell-center', cellTemplate: this.infoTemplate },
            { name: 'Action',        prop: 'config_id',         width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];
        this.loadDropdownsAndList();
    }

    loadDropdownsAndList() {
        this.aiFollowupConfigService.getDropdowns().then((res: any) => {
            if (res.success) { this.dropdowns = res; }
            this.pageCallback({ offset: 0 });
        });
    }

    pageCallback(pageInfo: any) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getList();
        }
    }

    onOpenedFilter() {}

    clearFilter() {
        this.filterData = { search_data: '' };
        this.applyFilter();
    }

    applyFilter() {
        this.filterPanel.close();
        this.getList();
    }

    sortCallback(sortInfo: any) {
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy  = sortInfo.sorts[0].prop;
        this.getList();
    }

    onChangePageSize(limit: number) {
        this.page.limit = limit;
        this.getList();
    }

    getList() {
        const params = {
            start:       `${this.page.offset}`,
            limit:       `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir:    `${this.page.orderDir}`,
            filter:      JSON.stringify(this.filterData)
        };
        this.isLoadMask = this.aiFollowupConfigService.getList(params).then((res: any) => {
            this.loadingIndicator = false;
            this.page.count = res.totCnt;
            this.configData = res.data;
        });
    }

    toggleInfo(row: any) {
        row._showInfo = !row._showInfo;
    }

    getTrackDayName(trackDayId: number): string {
        const found = (this.dropdowns.trackDays || []).find((d: any) => +d.track_day_id === +trackDayId);
        return found ? found.track_day_name : '';
    }

    onAddEdit(mode: string, row: any) {
        this.bsModalRef = this.modalService.show(AddEditAiFollowupConfigComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg'
        });
        row['mode'] = mode;
        this.bsModalRef.content.title      = mode + ' AI Followup Configuration';
        this.bsModalRef.content.configData = Object.assign({}, row, { track_day_config: row.track_day_config ? JSON.parse(JSON.stringify(row.track_day_config)) : [] });
        this.bsModalRef.content.dropdowns  = this.dropdowns;
        this.bsModalRef.content.loadEvent.subscribe(() => { this.getList(); });
    }

    onDelete(row: any) {
        swal({
            title: 'Are you sure to Delete?',
            text: 'Delete configuration for: ' + row.ai_status_name + '?',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(() => {
            this.isLoadMask = this.aiFollowupConfigService.delete(row.config_id).then((res: any) => {
                if (res.success) {
                    this.getList();
                    swal('Deleted', res.message, 'success');
                } else {
                    swal('ERROR', res.message, 'error');
                }
            });
        }, () => {});
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/aiFollowupConfig/aiFollowupConfig.component.ts